import React from "react"
import UsageGuideCardProps from "./usage-guide-card-props.interface";
import "./_usage-guide-card.scss";
import { ReactComponent as CloseIcon } from "../../../../../assets/icons/close-cross-icon.svg";

const UsageGuideCard = ({children, isMainCardType, handleClose}:UsageGuideCardProps) => 
    <div className={`usage-guide-card${isMainCardType? '--main-card': '--common-card'}`}>
        <button className="close-btn" type="button" onClick={handleClose}><span className="visually-hidden">Close</span><CloseIcon/></button>
        {children}
    </div>
;

export default UsageGuideCard;
